import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BearerHttpService } from '../../bearer-http';
import { DAL_OPTIONS, DalOptions } from '../../dal.module';

@Injectable({ providedIn: 'root' })
export class InkApi {
  constructor(
    private bearerHttpService: BearerHttpService,
    @Inject(DAL_OPTIONS) private options: DalOptions
  ) {}

  public get<T>(model: string) {
    return (path: string, params?: HttpParams) => {
      const endpoint = this.getEndPoint(model, path);
      return this.bearerHttpService.get<T>(endpoint, params);
    };
  }

  public post<T>(model: string) {
    return (path: string, body: object = {}, params?: HttpParams) => {
      const endpoint = this.getEndPoint(model, path);
      return this.bearerHttpService.post<T>(endpoint, body, params);
    };
  }

  public delete<T>(model: string) {
    return (path: string, params?: HttpParams) => {
      const endpoint = this.getEndPoint(model, path);
      return this.bearerHttpService.delete<T>(endpoint, params);
    };
  }

  public patch<T>(model: string) {
    return (path: string, body: object = {}, params?: HttpParams) => {
      const endpoint = this.getEndPoint(model, path);
      return this.bearerHttpService.patch<T>(endpoint, body, params);
    };
  }

  public put<T>(model: string) {
    return (path: string, body: object = {}, params?: HttpParams) => {
      const endpoint = this.getEndPoint(model, path);
      return this.bearerHttpService.put<T>(endpoint, body, params);
    };
  }

  private getEndPoint(model: string, path: string) {
    if (!path) return `${this.options.apiV2BaseUrl}/${model}`;
    return `${this.options.apiV2BaseUrl}/${model}/${path}`;
  }
}
